import jhcLoading from '@/src/module/jhc-loading'
import browserFilter from '@/src/module/jhc-browser-filter'
import React, {Component} from 'react';
import ReactDOM from 'react-dom';

class RoutingClass {
	constructor ( option ) {
		this.wrapper= option.wrap,
		this.menuCont= option.menu,
		this.trMask= option.loading,
		this.routeFile= option.routeFile,
		this.crtSubMenu= null;
		this.beforeRender= option.beforeRender || null;
		this.afterRender= option.afterRender || null;
	}

	config () {
		var that= this;
		axios.get(this.routeFile)
		.then(function (res) {
			that.config= res.data;
			that.RounteInit();
		})
		.catch(function (error) {
			console.log(error);
		});
	}
	
	getMenuElem ( categoryName, elems ) {
		let target;
		_jh.each(elems, (i, v)=> {
			if( categoryName== v.pathname ) {
				target= v;
				return false;
			}

			if( categoryName== v.dataset.routeName ) {
				target= v;
				return false;
			}
		});
		return target;
	}

	getMenu ( routeName ) {
		if( this.config.router[routeName] ) {
			const routingName= this.config.router[routeName].hasOwnProperty('route') ? this.config.router[routeName].route : routeName;
			const	menuName= this.config.router[routingName].category || this.config.router[routingName].category;
			const elems= this.menuCont.getElementsByClassName('item');
			const target= this.getMenuElem(menuName, elems);

			if( target ) {
				var submenu= this.menuCont.getElementsByClassName('sub-menu-list')[0];
				if( this.crtSubMenu ) this.crtSubMenu.classList.remove("selected");
				if( this.config.router[routingName].submenu ) 
				{
					var submenuName= this.config.router[routingName].submenu,
						subtarget= this.menuCont.querySelectorAll('[data-route-name="' +submenuName+'"]')[0];
					subtarget.classList.add("selected");
					this.crtSubMenu= subtarget;
				}
			
				if( this.crtMenu ) this.crtMenu.classList.remove("selected");
				target.classList.add("selected");
				this.crtMenu= target;
			}
		}
	}

	checkLang ( link ) {
		this.lang= document.documentElement.lang;
		this.langPath= this.config.langList[this.lang].path;
		var langPath= '/'+ this.lang
			, linkpage= 
					( this.config.langRange && this.config.langRange.indexOf(this.lang) !== -1 && this.lang !== 'ko' ) ? 
					link.split(langPath)[1] : link;
		return linkpage;
	}

	checkRoute ( linkpage ) {
		
		const route= {
			routeName: '', 
			routeNameState: linkpage
		};
		if( this.config.router[linkpage] ) {
			route.routeName= linkpage;
		} else {
			console.dir(this.config.router)
			const rootUrl= `/${linkpage.split('/')[1]}`;
			if( this.config.router[rootUrl] ) route.routeName= rootUrl;
			else { 
				route.routeName= '404';
				route.routeNameState= '404';
			}
		}
		return route;
	}

	RounteInit () {
		var that= this, linkpage,
			routeName= '/',
			link = document.location.pathname,
			linkpage= this.checkLang(link),
			linkpage= !linkpage ? '/' : linkpage,
			// routeName= (this.config.router[linkpage] && linkpage) || '404';
			route= this.checkRoute(linkpage),
			routeName= route.routeName,
			routeNameState= route.routeNameState;
		// console.log(routeName)
		const urlParam= routeNameState + document.location.search;
		history.pushState({name: routeNameState}, routeNameState, urlParam);
		this.setRouteName(routeName);
		this.getMenu(routeName);
		

		if( browserFilter() === 11 ) {
			setTimeout(e=> {
				this.afterRenderDefault();
				this.afterRender && this.afterRender();
			});
		} else {
			if( document.readyState === 'complete' ) {
				this.afterRenderDefault();
				if( this.afterRender ) this.afterRender();
			} else {
				document.addEventListener('readystatechange', this.afterRenderDefaultEvt());
				if( this.afterRender ) document.addEventListener('readystatechange', this.afterRender);
			}
		}

		var	relPath= link.split('/'),
		    result= relPath[1].split('/'),
			state= relPath[1].split('/');
		
		window.onpopstate= function(event) {
			var currentState= history.state;
			console.dir(currentState)
			console.dir(event)
			if(currentState) {
				that.routing(currentState.name, true);
			}
		};
	}
	
	afterRenderDefaultEvt () {
		return (e)=> this.afterRenderDefault();
	}

	afterRenderDefault () {
		// console.log('afterRenderDefault')
		this.scriptTransform(this.wrapper, this.currentRouteParam.script);
	}

	setRouteName ( routeName, uri ) {
		this.beforeRender && this.beforeRender(this);
		this.currentRoute= uri || routeName;
		this.currentRoutePath= this.config.router[routeName].route || routeName;
		this.currentRouteParam= this.config.router[this.currentRoutePath];
		return this.currentRoutePath;
	}

	getcurrentRoutePath () { return this.currentRoutePath; }

	routing  ( routeName, historyPush ) {
		if ( routeName === '' ) return;
		const routePath = routeName.split('?');
		this.setRouteName(routePath[0], routeName);
		this.getMenu(this.currentRoutePath);
		this.pageRequest(routePath[0], routeName, historyPush);
	}

	pageRequest ( routeName, uri, historyPush ) {
		var param= {}
			, routePath= this.currentRoutePath
			, langCtgPath= routePath.match(/[^(\/)][a-z0-9!@#$%^*()\-_=+\\\|\[\]{};:\'",.<>\/?]+/gim)
			, langCtgPath= langCtgPath ? langCtgPath[0] : './'
			, url= routeName;
		
		if( routePath === undefined ) return;
		
		param= {};
		param.lang= document.documentElement.lang;
		param.gateway= 'menu';
		// _jh.each(this.currentRouteParam, (i, v)=> { param[i]= v; });
		if( !historyPush ) history.pushState({name: this.currentRoute}, this.currentRoute, this.currentRoute);

		this.axiosSource && this.axiosSource.cancel('Operation canceled by the user.');
		this.axiosSource= axios.CancelToken.source();
		this.axiosCancelToken= this.axiosSource.token;
		
		jhcLoading.show(this.wrapper);
		axios.get(url, {
			params: param,
		  cancelToken: this.axiosCancelToken
		})
  	.then( (res)=> {
  		this.pageCallback(this.wrapper, res, this.currentRouteParam, langCtgPath);
  		this.afterRenderDefault();
  		this.afterRender && this.afterRender(this);
  	})
  	.catch(function (error) {
    	console.log(error);
  	});
	}

	setMetaTitle ( params ) {
		const info= params || this.currentRouteParam;
		const titleElem= document.getElementsByTagName('title');
		titleElem[0].innerHTML= this.routeContLang(info.title) + " - " + this.routeContLang(info.name);
	}

	pageCallback ( elem, res, params, langCtgPath ) {
		// this.langRoute(langCtgPath);
		if(this.currentRouteParam) this.setMetaTitle(params);
		elem.innerHTML= '';
		elem.insertAdjacentHTML('beforeend', res.data);
		
		window.scrollTo(0,0);
	}

	langRoute (langCtgPath) {
		const target= this.topArea.getElementsByClassName('sub-lang-item');
		_jh.each( target, function(i, v) {
			console.log(`/${v.dataset.lang}${langCtgPath}`);
			v.href=`/${v.dataset.lang}${langCtgPath}`;
		});
	}

	scriptTransform ( elem, script ) {
		_jh.each(script, function (i, v) {
			const s = document.createElement("script");
			s.src = v;
			s.async= true;
			elem.appendChild(s);
		});
	}

	routeContLang ( keypath ) {
		var value=  typeof keypath === 'object' ? keypath[this.lang] : keypath;
		return value;
	}

}

export const Routing= RoutingClass;